<template>
  <div class="pmw-selected-item">
    <Icon icon="file" class="pmw-selected-item--icon" />

    <PmwParagraph>
      {{ item[itemNameKey] }}
    </PmwParagraph>

    <!-- REMOÇÃO DE ITEM SELECIONADO -->
    <button class="pmw-selected-item--remove" @click="removeItem(item)">
      <Icon
        :icon="'x-icon'"
        class="pmw-selected-item--icon pmw-selected-item--icon-delete"
      />
    </button>
  </div>
</template>

<script>
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph/PmwParagraph.vue'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'

export default {
  name: 'PmwSelectedItem',

  components: {
    PmwParagraph,
    Icon
  },

  props: {
    item: {
      type: Object,
      default: () => ({})
    },

    itemIdKey: {
      type: String,
      default: 'id'
    },

    itemNameKey: {
      type: String,
      default: 'name'
    }
  },

  methods: {
    /**
     * Remove um único item
     * @param {object} item Objeto do item removido
     */
    removeItem(item) {
      this.$emit('deleteItem', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-selected-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: pmw-space(2) pmw-space(4);

  border: {
    bottom: 1px solid $gray-border;
  }

  &--icon {
    margin-right: pmw-space();

    &-delete {
      width: 12px;
      cursor: pointer;
    }
  }

  &--remove {
    @include reset-button;
    justify-self: flex-end;
    margin-right: 0;
    margin-left: auto;
    height: auto;
    line-height: 10px;
    padding: 0;
    border: none;
    background: none;
    color: $pmw-gray-mid;
    align-items: center;

    &:hover {
      color: $pmw-gray-dark;
    }
  }
}
</style>
